/* unplugin-vue-components disabled */import script from "./PointsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsDetails.vue?vue&type=script&setup=true&lang=js"

import "./PointsDetails.vue?vue&type=style&index=0&id=111c2e09&lang=scss"

const __exports__ = script;

export default __exports__